/* NODE PACKAGES */
import React from 'react';
import { AxiosRequestConfig } from 'axios';
/* TYPES */
import { APIRegistryList } from 'api/types';
/* HOOKS */
import {useAxios} from 'hooks';

const GetPSLList:AxiosRequestConfig = { method: 'GET', url: '/api/tld_lists', }

export type RegistryListStore =
  {
  loading: boolean;
  error:any;
  data: APIRegistryList[] | null;
  refresh: () => void;
  };

function useRegistryListStore(): RegistryListStore
  {
  const [response, error, loading, callAxios] = useAxios(GetPSLList);
  const [data, setData] = React.useState<APIRegistryList[] | null>(null);

  React.useEffect(() =>
    {
    if (response) setData(response.tld_lists?.sort((a:APIRegistryList, b:APIRegistryList) => a.name.localeCompare(b.name)) ?? []);
    }, [response]);

  const refresh = () => callAxios();

  return {loading, error, data, refresh} as RegistryListStore;
  }

export default useRegistryListStore;
